import {Directive, ElementRef, Input, OnChanges, inject} from '@angular/core';

/*
This directive helps angular get to know that img src was
actually updated. It is needed because when we change img
the actual src does not change, so on next change detection
we tell angular that it may be new img, and please show it
* */
@Directive({
  selector: '[mcImgCacheBuster]',
  standalone: true,
})
export class ImgCacheBusterDirective implements OnChanges {
  private el = inject<ElementRef<HTMLImageElement>>(ElementRef);

  @Input() src: string = '';
  ngOnChanges(): void {
    this.reloadImage();
  }

  private reloadImage(): void {
    this.el.nativeElement.src = this.src + '?' + Date.now(); // Update the src attribute
  }
}
